import { render, staticRenderFns } from "./StepChoices.vue?vue&type=template&id=57fcee81"
import script from "./StepChoices.vue?vue&type=script&lang=js"
export * from "./StepChoices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports